import { render, staticRenderFns } from "./QuickNotes.vue?vue&type=template&id=1a0d4f86"
import script from "./QuickNotes.vue?vue&type=script&lang=js"
export * from "./QuickNotes.vue?vue&type=script&lang=js"
import style0 from "./QuickNotes.vue?vue&type=style&index=0&id=1a0d4f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports